import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import { pdfjs } from 'react-pdf' // Import react-pdf components
import { MultipleDocumentsType } from '../types/interface'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

export const createPdf = async (text: string[]) => {
  // Create pdf method
  const pdfDoc = await PDFDocument.create()
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
  const page = pdfDoc.addPage()

  const { height } = page.getSize()
  const fontSize = 14
  page.drawText(text.join('\n'), {
    color: rgb(0.95, 0.1, 0.1),
    font: helveticaFont,
    size: fontSize,
    x: 50,
    y: height / 2 + fontSize / 2,
  })

  const pdfBytes = await pdfDoc.save()
  return pdfBytes
}

export const newPdf = async (file: File) => {
  // Create pdf method
  const pdfDoc = await PDFDocument.create()

  const image =
    file.type === 'image/png'
      ? await pdfDoc.embedPng(await file.arrayBuffer())
      : await pdfDoc.embedJpg(await file.arrayBuffer())

  const imageDims = image.scale(1)
  const page = pdfDoc.addPage([imageDims.width, imageDims.height])

  page.drawImage(image, {
    height: imageDims.height,
    width: imageDims.width,
    x: page.getWidth() / 2 - imageDims.width / 2,
    y: page.getHeight() / 2 - imageDims.height / 2,
  })

  const pdfBytes = await pdfDoc.save()
  return pdfBytes
}

export const modifyPdf = async (url: string, text: string, date: string) => {
  // Modify pdf method
  const checkboxText =
    'I understand and agree to the terms set forth in this agreement and any additional documents addressed herein.'
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer())

  const pdfDoc = await PDFDocument.load(existingPdfBytes) // Load pdf from url
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

  const form = pdfDoc.getForm()
  const pages = pdfDoc.getPages()
  const signPage = pages[1]

  // const { width, height } = signPage.getSize()

  const checkField = form.createCheckBox('check')
  const signatureField = form.createTextField('signature')
  const dateField = form.createTextField('date')

  checkField.addToPage(signPage, {
    height: 14,
    width: 14,
    x: 24,
    y: 162,
  })

  signatureField.addToPage(signPage, {
    height: 14,
    x: 108,
    y: 138,
  })

  dateField.addToPage(signPage, {
    height: 14,
    x: 108,
    y: 118,
  })

  checkField.check()
  signatureField.setText(text)
  dateField.setText(date)

  signPage.drawText(checkboxText, {
    color: rgb(0, 0, 0),
    font: helveticaFont,
    size: 10,
    x: 46,
    y: 165,
  })

  signPage.drawText('Driver Signature:', {
    color: rgb(0, 0, 0),
    font: helveticaFont,
    size: 10,
    x: 24,
    y: 142,
  })

  signPage.drawText('Date:', {
    color: rgb(0, 0, 0),
    font: helveticaFont,
    size: 10,
    x: 24,
    y: 122,
  })

  form.flatten()
  const pdfBytes = await pdfDoc.save()
  return pdfBytes
}

export const downloadPdf = async (
  pdfBytes: Uint8Array,
  text: string,
  type: string
) => {
  // Download generated pdf method
  const blob = new Blob([pdfBytes], { type })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = text
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// Disabling the ESLint check for this function due to the current difficulty of testing it after refactoring
// TODO: Refactor this function when some task requires changes on the place this function is called
/* eslint-disable */
export const mergePdf = async (pdfs: MultipleDocumentsType[]) => {
  // Merge pdf method
  const pdfDocument = await PDFDocument.create()

  for (const pdf of pdfs) {
    const document = await PDFDocument.load(pdf.pdf, { ignoreEncryption: true })
    const copiedPages = await pdfDocument.copyPages(
      document,
      document.getPageIndices()
    )
    copiedPages.forEach((page) => pdfDocument.addPage(page))
  }
  return await pdfDocument.save()
}

export const pdfUrltoImage = async (pdf: string) => {
  // Convert pdf url to image
  const _PDF_DOC = await pdfjs.getDocument(pdf).promise // Get the PDF document
  const imageList = [] // Create an array to store the images
  const canvas = document.createElement('canvas') // Create a canvas element
  for (let i = 1; i <= _PDF_DOC.numPages; i++) {
    // Loop through the pages
    const page = await _PDF_DOC.getPage(i) // Get the page
    const viewport = page.getViewport({ scale: 2 }) // Get the viewport
    canvas.width = viewport.width // Set the canvas width
    canvas.height = viewport.height // Set the canvas height
    const renderContext: any = {
      canvasContext: canvas.getContext('2d'),
      viewport,
    } // Create the render context
    await page.render(renderContext).promise // Render the page
    imageList.push(canvas.toDataURL('image/jpeg')) // Push the image to the image list
  }
  return imageList // return the image list
}
/* eslint-enable */
